<div class="barcode-ov">
    <canvas #barcodeCanvas class="barcode-ov"></canvas>
</div>